import { React } from "react";

import MultiStepNav from "./components/MultiStepNav";

import "./index.css";

/**
 * Componente principal para completar perfil profesional del médico.
 *
 * @returns Component react.
 */
function App() {

  return (
    <div className="row">
      <MultiStepNav />
    </div>
  );

}

export default App;
